module.exports = __webpack_public_path__ + "static/radikal_black-webfont-cc25ec29fc3fcf4d4d14bd141ccdb16e.woff";